import {InfoWindow} from "@react-google-maps/api";

const CustomInfoWindow = ({anchor, onCloseClick, dealer}) => {
    const {name, city, zip_code, website, address} = dealer
    const websiteUrl = website.includes('http') ? website : `https://${website}`

    return (
        <InfoWindow anchor={anchor} onCloseClick={onCloseClick}>
            <div className='mtt-info-window'>
                <a href={websiteUrl} className='mtt-info-window__heading title' rel='noreferrer noopener' target='_blank'>
                    {name}
                    <svg xmlns='http://www.w3.org/2000/svg' width="18.414" height='18.414' viewBox='0 0 18.414 18.414'>
                        <path d='M7 3.414H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4m-4-10h6m0 0v6m0-6-10 10'
                              fill='none' stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'
                              opacity='.4'/>
                    </svg>
                </a>
                <div className='mtt-info-window__address'>
                    {address}
                </div>
                <div className='mtt-info-window__address'>
                    {zip_code}, {city}
                </div>
            </div>
        </InfoWindow>
    )
}

export default CustomInfoWindow